"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hero = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var Hero = function (_a) {
    var logoImg = _a.logoImg, bgImg = _a.bgImg, logoText = _a.logoText, splitButtonProps = _a.splitButtonProps, _b = _a.gradient, gradient = _b === void 0 ? "darkerLeft" : _b, _c = _a.csx, csx = _c === void 0 ? {} : _c;
    return (theme_ui_1.jsx(theme_ui_1.Box, { sx: __assign({ height: ["352px", "352px", "590px"], width: "100%" }, csx) },
        theme_ui_1.jsx(__1.BGImageBox, { img: bgImg, gradient: gradient, csx: {
                padding: ["0", "0", "0", "0", "138px 0 0 251px"],
                display: "flex",
                justifyContent: [
                    "center",
                    "center",
                    "center",
                    "center",
                    "flex-start",
                ],
                alignItems: [
                    "center",
                    "center",
                    "center",
                    "center",
                    "flex-start",
                ],
            } },
            theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                } },
                theme_ui_1.jsx(theme_ui_1.Box, { sx: {
                        maxWidth: ["231px", "364px", "582px"],
                        height: ["77px", "77px", "123px"],
                        marginBottom: ["20px", "20px", "30px"],
                    } },
                    theme_ui_1.jsx(__1.Image, { src: logoImg, sx: { height: "100%" }, alt: "logo", title: "" })),
                theme_ui_1.jsx(theme_ui_1.Box, { sx: {
                        marginBottom: "30px",
                        maxWidth: ["300px", "472px"],
                    } },
                    theme_ui_1.jsx(__1.Heading, { as: "h3", variant: "text.h4" }, logoText)),
                theme_ui_1.jsx(theme_ui_1.Box, null, splitButtonProps && (theme_ui_1.jsx(__1.SplitButton, { leftText: splitButtonProps.buttonLeftText, rightText: splitButtonProps.buttonRightText, onClick: splitButtonProps.onButtonClick })))))));
};
exports.Hero = Hero;
